import React, { useState, useEffect } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import eventContext from "../../../contexts/EventContext";
import Loading from "../../../components/Loading";
import NavbarPro from "../../../components/NavigationBar/NavbarPro";
import EventHeadPro from "./EventHead/EventHeadPro";
import EventAboutPro from "./EventAboutPro";
import EventPricingPro from "./EventPricing/EventPricingPro";
import EventSpeakersPro from "./EventSpeakersPro";
import EventWorkshopsPro from "./EventWorkshopsPro";
import EventFooterPro from "./EventFooterPro";
import EventSponsorsPro from "./EventSponsorsPro";
import EventVenuePro from "./EventVenuePro";
import EventShoutPro from "./EventShoutPro";
import Link from "next/link";
import AgendaPro from "./AgendaPro";
import { getTicketData } from "../../../crud/dedicatedEvent-crud";
import { pricingSampleData } from "../../../data/sampleEvent";
import _ from "lodash";
import moment from "moment";
import { errorToaster } from "../../../helpers/utils";

const EventPagePro = ({
	isReady,
	eventUrl,
	query,
	eventData,
	samplePage = false,
	ticketsData,
	groupDiscounts
}) => {
	// const [eventData, setEventData] = useState(eventData)
	const [currentUrl, setCurrentUrl] = useState("");
	const [CurrSection, setCurrSection] = useState("about");
	const [ticketData, setTicketData] = useState(ticketsData);
	const router = useRouter();
	let newQuery = { ...query };
	delete newQuery.eventUrl;
	const faviconIconUrl =
		eventData.fav_icon_urls && eventData.fav_icon_urls["favicon.ico"];

	useEffect(() => {
		//to pass over the
		if (!samplePage) {
			if (isReady && eventUrl) {
				let currentUrl = router.asPath;
				if (currentUrl.includes("#")) currentUrl = currentUrl.split("#")[0];
				setCurrentUrl(currentUrl);
			} else if (isReady && !eventUrl) router.push("/error");
		}
	}, [eventUrl]);

	const availableTabs = {
		about: eventData.description,
		speakers: eventData?.has_speakers,
		workshops: eventData?.has_workshops,
		sponsors: eventData?.has_sponsors,
		agenda: eventData?.has_agenda,
		venue:
			(!eventData.is_virtual && eventData.venue) ||
			eventData.event_url === "wencarnival",
	};

	const hideHighlight =
		(eventData?.expected_speakers === 0 ||
			eventData?.expected_speakers === null) &&
		(eventData?.expected_attendees === 0 ||
			eventData?.expected_attendees === null);

	let mybutton = null;
	var navbar = null;

	function scrollFunction() {
		if (
			document.body.scrollTop > 400 ||
			document.documentElement.scrollTop > 400
		) {
			mybutton.style.display = "block";
		} else {
			mybutton.style.display = "none";
		}
	}

	function scrollToSection(sectionId) {
		const element = document.getElementById(sectionId);
		if (element) {
			const offsetTop = element.offsetTop;
			const scrollToPosition = offsetTop - 80;
			window.scrollTo({
				top: scrollToPosition,
				behavior: "smooth",
			});
			// Update URL with fragment identifier
			const url = `${window.location.pathname}#${sectionId}`;
			window.history.replaceState({}, document.title, url);
		}
	}
	// When the user clicks on the button, scroll to the top of the document
	function topFunction() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	}

	// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
	function myFunction() {
		if (window.pageYOffset >= 150) {
			navbar.style.boxShadow = "rgb(196 196 196) 0px 0px 5px";
		} else {
			navbar.style.boxShadow = "none";
		}
	}

	const getTicketDataFunction = async () => {
		try {
			const res = await getTicketData(eventUrl);
			let uncategorized = res.data.uncategorized;
			let allTickets = [...uncategorized];
			res.data.categorized = res.data.categorized.sort(
				(a, b) => a.category_order - b.category_order,
			);
			res.data.categorized.forEach((category) => {
				category.tickets = category.tickets.map((ticket) => {
					ticket.category = {
						category_name: category.category_name,
						category_description: category.category_description,
						category_id: category.category_id,
						category_order: category.category_order,
						is_expanded: category.is_expanded,
					};
					return ticket;
				});
				allTickets = [...allTickets, ...category.tickets];
			});
			let ticketDetails = allTickets;
			let orderedTicket = ticketDetails.sort((a, b) => {
				// Sort the forms by from orderzz
				return a.ticket_order - b.ticket_order;
			});
			let newTickets = [];
			orderedTicket.map((ticket) => {
				if (!ticket.hidden_ticket) newTickets.push(ticket);
				else return;
			}); // temporary
			setTicketData(newTickets);
		} catch (err) {
			console.log(err);
			errorToaster(
				"Something went wrong while trying to get ticket, please try again later",
			);
		}
	};
	useEffect(() => {
		mybutton = document.getElementById("scrollDiv");
		window.onscroll = function () {
			scrollFunction(), myFunction();
		};
		navbar = document.getElementById("sticky");
	}, []);

	useEffect(() => {
		if (samplePage) {
			setTicketData(pricingSampleData.uncategorized);
		} else {
			//getTicketDataFunction();
		}
	}, [eventUrl]);

	const isTicketSoldOut = () => {
		var todaysTime = moment().valueOf();
		let event_end_timestamp = `${eventData.end_date} ${eventData.end_time}`;
		let eventEndTime = moment.utc(event_end_timestamp).local().valueOf();
		if (!_.isEmpty(ticketData)) {
			let soldoutTickets = ticketData.filter(
				(ticket) =>
					(ticket.sold_out === true || ticket.remaining_count <= 0) &&
					!ticket.waitlist_enabled,
			);
			if (soldoutTickets.length === ticketData.length) {
				return "Sold Out";
			}
		}
		if (eventData.is_free) {
			return "Register";
		} else if (todaysTime > eventEndTime) {
			return "Expired";
		} else return "Buy Now";
	};

	return (
		<>
			<eventContext.Provider value={{ eventData }}>
				{Object.keys(eventData).length !== 0 ? (
					<>
						{faviconIconUrl ? (
							<Head>
								<link rel="icon" href={faviconIconUrl} />
							</Head>
						) : (
							<Head>
								<link rel="icon" href="./favicon/globe.ico" />
							</Head>
						)}
						<div className="container-color">
							<div
								id="scrollDiv"
								style={{
									display: "none",
									background: "#f6f6fc",
									borderRadius: "50%",
									boxShadow: "0px 0px 7px rgb(77 77 77)",
								}}
								onClick={topFunction}
								className="icon-scroll"
							>
								<img src="/img/scroll-top.svg" />
							</div>
							<div
								className="sticky"
								id="sticky"
								style={{ backgroundColor: "#f6f6fc" }}
							>
								<NavbarPro
									availableTabs={availableTabs}
									CurrSection={CurrSection}
									disableLogo={eventUrl == "linkedin" ? true : false}
									mobileNavbar={false}
									eventPage={true}
									ticketData={ticketData}
									scrollToSection={scrollToSection}
								/>
							</div>
							<div className="content">
								<EventHeadPro
									eventUrl={eventUrl}
									hideHighlight={hideHighlight}
									currentUrl={currentUrl}
									buttonText={isTicketSoldOut()}
									hasCoupons={eventData.has_coupons}
									ticketData={ticketData}
								/>
								{eventData.description && (
									<Link href="#about" onClick={(e) => {
										e.preventDefault();
									}}
									className="custom-link">
										<EventAboutPro setCurrSection={setCurrSection} />
									</Link>
								)}
								<Link href="#tickets" onClick={(e) => {
									e.preventDefault();
								}}
								className="custom-link">
									<EventPricingPro
										eventUrl={eventUrl}
										setCurrSection={setCurrSection}
										newQuery={newQuery}
										samplePage={samplePage}
										hasCoupons={eventData.has_coupons}
										hasAccessCodes={eventData.has_access_codes}
										ticketData={ticketData}
										getTicketDataFunction={getTicketDataFunction}
										setTicketData={setTicketData}
										groupDiscounts={groupDiscounts}
									/>
								</Link>
								{(eventData?.speaker_section_description || eventData?.has_speakers === true) && (
									<Link href="#speakers" onClick={(e) => {
										e.preventDefault();
									}}
									className="custom-link">
										<EventSpeakersPro
											eventUrl={eventUrl}
											setCurrSection={setCurrSection}
											eventData={eventData}
											samplePage={samplePage}
										/>
									</Link>
								)}
								{eventData?.has_workshops === true && (
									<Link href="#workshops" onClick={(e) => {
										e.preventDefault();
									}}
									className="custom-link">
										<EventWorkshopsPro
											eventUrl={eventUrl}
											setCurrSection={setCurrSection}
											samplePage={samplePage}
										/>
									</Link>
								)}

								{eventData?.has_agenda === true && (
									<Link href="#agenda" onClick={(e) => {
										e.preventDefault();
									}}
									className="custom-link">
										<AgendaPro
											eventUrl={eventUrl}
											setCurrSection={setCurrSection}
											eventData={eventData}
											samplePage={samplePage}
										/>
									</Link>
								)}
								{eventData?.has_sponsors === true && (
									<Link href="#sponsors" onClick={(e) => {
										e.preventDefault();
									}}
									className="custom-link">
										<EventSponsorsPro
											eventUrl={eventUrl}
											setCurrSection={setCurrSection}
											eventData={eventData}
											samplePage={samplePage}
										/>
									</Link>
								)}
								{((!eventData.is_virtual && eventData.venue) ||
									eventData.event_url === "wencarnival") && (
										<Link href="#venue" onClick={(e) => {
											e.preventDefault();
										}}
										className="custom-link">
											<EventVenuePro setCurrSection={setCurrSection} />
										</Link>
									)}
								<EventShoutPro />
								{/* <EventFooterPro /> */}
							</div>
						</div>
					</>
				) : (
					<div className=" vh-100 d-flex justify-content-center align-items-center bg-light align-self-center event-header-container event-header-container-image px-0">
						<Loading color="#141B25" />
					</div>
				)}
			</eventContext.Provider>
			<style jsx global>{`
		.custom-link {
			color: inherit;
			cursor: default;
		}	
		.custom-link:hover {
			color: inherit;
			cursor: default;
		}	
        .container-color {
          background: #f6f6fc;
        }
        .sticky {
          position: fixed;
          top: 0;
          width: 100%;
          z-index: 2000;
          transition: box-shadow 0.3s ease-in-out;
        }
        .icon-scroll {
          position: fixed;
          bottom: 4%;
          right: 2%;
          z-index: 70;
        }
        .icon-scroll * {
          width: 40px;
          cursor: pointer;
          height: 40px;
        }
        .content {
          margin-top: 15px;
		  background-color:#f6f6fc;
        }
        .sticky + .content {
          padding-top: 60px;
        }
        @media only screen and (max-width: 576px) {
          .content {
          margin-top: 0px;
		  background-color:#f6f6fc;
        }
        }
      `}</style>
		</>
	);
};

export default EventPagePro;